export const LANG_HE = 1037;
export const LANG_EN = 1033;
